import { render, staticRenderFns } from "./errCode.vue?vue&type=template&id=76660bd8&scoped=true&"
import script from "./errCode.vue?vue&type=script&lang=js&"
export * from "./errCode.vue?vue&type=script&lang=js&"
import style0 from "./errCode.vue?vue&type=style&index=0&id=76660bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76660bd8",
  null
  
)

export default component.exports